import { contactContent } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[700px] mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            {contactContent.title}
          </h2>
          <p className="text-sm text-foreground-500 mb-3">{contactContent.subtitle}</p>
          <p className="text-sm text-foreground-600 leading-relaxed mb-8">
            {contactContent.description}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {contactContent.methods.map((m, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl p-5 border border-background-200/70"
              >
                <div className={`w-11 h-11 flex items-center justify-center ${m.color} rounded-lg mx-auto mb-3`}>
                  <i className={`${m.icon} text-white text-lg`}></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">{m.label}</p>
                <p className="text-sm font-medium text-foreground-800 break-all">{m.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}